import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { AllergyIntoleranceBundle } from '../../../../../types/FHIRTypes/Bundle'
import { AllergyIntolerance as FHIRAllergyIntolerance } from '@teschglobal/tg-fhir-react-components/dist/types'
import { AllergyIntolerance } from '@teschglobal/tg-fhir-react-components'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type AllergyDetailProps = {
    allergyDetailId: string | undefined;
}

const AllergyDetail: FC<AllergyDetailProps> = ({ allergyDetailId}) => {
    const { patientAccessFhirConfig } = useFhirConfig()
    const history = useHistory()

      const {
        data: allergy,
        isFetching,
        isLoading,
        isError
      }: UseQueryResult<FHIRAllergyIntolerance, Error> =
        useFhirResourceById('Patient Access', allergyDetailId || '', 'AllergyIntolerance')
    
      if (isFetching || isLoading) {
        return <FhirLoader />
      }
    
      if (!allergy || isError) {
        return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
      }


    return (
        <div>
            <section>
                <AllergyIntolerance
                    data={allergy}
                    fhirApiConfig={patientAccessFhirConfig}
                />
            </section>
        </div>
    )
}
export default AllergyDetail